/*
* @Author: zhengxiaowen
* @Date: 2018-10-11 14:56:27
* @Last Modified by: zhengxiaowen
* @Last Modified time: 2019-04-24 16:03:52
*/
import store from '@/common/store/StoreCommon'
import moment from 'moment'
import md5 from 'vux/src/tools/md5/index.js'
import base64 from 'vux/src/tools/base64/index.js'

import platform from "./platform";
import CryptoJS from "crypto-js"

let system = {}

/**
* h5启动（），接收到底座传递过来的初始化信息，在这个节点进行处理 (底座运行时)
* 该函数生效时回取缔默认的初始化过程
*/





/**
* h5启动
* 该函数生效时回取缔默认的初始化过程
*/




/**
* 全局查询参数
*/






system.getHeaders = function(){

let timestamp = moment().format('x')
let timestampArr = timestamp.split('');
let letter1 = timestampArr[timestampArr.length - 2];
let letter2 = letter1 % 4 + 1;
let sum = 0;
for (let i = 0; i < letter2; i++) {
sum += Number(timestampArr[i]);
}
let num = sum % 4 + 1;
let appsign = timestamp;
for (let i = 0; i < num; i++) {
appsign = md5(appsign);
}
let headers = {}
headers.appsign = appsign
headers.timestamp = timestamp
headers.appId = base64.encode(platform.systemCode)
headers.certificate = store.state.user.certificate

headers.AuthorizationCode = store.state.user.userInfo != null ? store.state.user.userInfo.authorizationCode : ""

headers['Gateway-Tag'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJHYXRld2F5LVRhZyI6MjE0MTQ4NTI5NzAzODYyMTg0N30.v-ifNOkW6SPyprF4K9s13CAJ43AcoAm8vxW2sY2QJNo'
return headers;
}


/**设置参数签名信息到请求头*/
system.setParamsSignature = (headers, params) => {
let _timestamp = headers.timestamp


let _val = CryptoJS.enc.Utf8.parse(_timestamp).toString(CryptoJS.enc.Base64);
let _key = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(_val, platform.systemCode));
let _params = JSON.stringify(params)

let _digestVal = CryptoJS.enc.Hex.stringify(CryptoJS.HmacSHA256(_params, _key));

headers["parameterSignature"] = _digestVal
}

/**配置返回数据为流数据的URL列表*/
system.streamUrlList = [
"/v2/file/batchDownload",
"/v2/file/download",
"/v2/file/downloadBody",
"/v1/largeFile/downloadBody",
"/v1/importExcelRestful/importExcel",
"/v1/importExcelRestful/downloadImportTemplate",
"/v1/exportExcelRestful/exportExcel",
"/v1/exportExcelRestful/customExportExcel",
"/v2/pageoffice/doFilePdfView",
"/generatorServer/v1/baseGeneratorRest/generatorCode",
"/v1/srmSup/largeFile/downloadTemplate"
]

export default system



// WEBPACK FOOTER //
// ./src/config/systemHook.js